module.exports = __webpack_public_path__ + "assets/download2.5481662d.svg";